import type { SVGProps } from 'react';

export const Facebook = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 0a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h16Zm-7.108 4.106a3.34 3.34 0 0 0-3.333 3.347v3.014h-2a.336.336 0 0 0-.334.335v2.008c0 .184.15.335.334.335h2v6.567a9.31 9.31 0 0 0 2.667.144v-6.712h2.6a.536.536 0 0 0 .53-.47l.2-1.605a.536.536 0 0 0-.53-.602h-2.8V8.123c0-.74.597-1.339 1.333-1.339h1.667a.335.335 0 0 0 .333-.335V4.44a.335.335 0 0 0-.333-.334h-2.334Z" />
    </svg>
  );
};
